module.exports = __webpack_public_path__ + "static/media/bkg10n.9bd56312.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/backgrounds/bkg10n.jpg
// module id = 474
// module chunks = 0